import React, { useState, useEffect, useRef } from "react";
import Axios from "axios";
import { URL_LIST_ALL } from "../configs/api";
import Moment from "react-moment";
import parse from 'html-react-parser';
import { useSelector } from "react-redux";
import iconsend from "../assets/img/icon-send.png";
import { linkify } from "../configs";

export default function MessageBox({ workId, targetId, user, type = 'item' }) {
    const { saveRealTimeData } = useSelector((state) => state.save);
    const [messages, setMessages] = useState([]);
    const [chatInput, setChatInput] = useState("");
    const [loading, setLoading] = useState(false);
    const chatEndRef = useRef(null);
    const inputRef = useRef(null);

    // State cho tính năng Tag
    const [showSuggest, setShowSuggest] = useState(false);
    const [usersSuggest, setUsersSuggest] = useState([]);

    const scrollToBottom = () => {
        chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
    };

    const fetchMessages = () => {
        if (!targetId) return;
        setLoading(true);
        Axios.get(`${URL_LIST_ALL}works_order_messages?limit=1000000&orderby=id-asc&target_id=${targetId}`, user.config)
            .then(res => {
                setLoading(false);
                if (res.data.status === "success") {
                    setMessages(res.data.data);
                    setTimeout(scrollToBottom, 100);
                }
            })
            .catch(err => { setLoading(false); console.error(err); });
    };

    useEffect(() => { fetchMessages(); }, [targetId]);

    useEffect(() => {
        if (saveRealTimeData && saveRealTimeData.event_type == "message" && Number(saveRealTimeData.target_id) === Number(targetId)) {
            setMessages((prev) => {
                if (prev.find(m => m.id === saveRealTimeData.id)) return prev;
                return [...prev, saveRealTimeData];
            });
            setTimeout(scrollToBottom, 100);
        }
    }, [saveRealTimeData, targetId]);

    // --- Logic Tag Tên ---
    const onComment = (val) => {
        setChatInput(val);
        const words = val.split(/\s/);
        const lastWord = words[words.length - 1];

        if (lastWord.startsWith('@')) {
            const keyword = lastWord.substring(1);
            if (keyword.length > 0) {
            
                getUserByTags(keyword);
            } else {
                setShowSuggest(false);
            }
        } else {
            setShowSuggest(false);
        }
    };

    const getUserByTags = (tags) => {
        // Sử dụng workId (id của dự án lớn) để search users trong cùng workflow
        Axios.get(`${URL_LIST_ALL}search_users_tags?limit=1000&search_key=${tags}`, user.config)
            .then((res) => {
                if (res.data.status === "success") {
                    setUsersSuggest(res.data.data);
                    setShowSuggest(res.data.data.length > 0);
                }
            }).catch((e) => console.log(e));
    };

    const handleSelectUser = (u) => {
        const words = chatInput.split(/\s/);
        let email = u.email;
        let alias = email.substring(0, email.indexOf('@'));
        
        words[words.length - 1] = `@${alias}`;
        let newMessage = words.join(' ') + ' ';
        
        setChatInput(newMessage);
        setShowSuggest(false);

        // Focus lại vào input và đưa con trỏ xuống cuối
        setTimeout(() => {
            inputRef.current?.focus();
            const length = newMessage.length;
            inputRef.current?.setSelectionRange(length, length);
        }, 0);
    };

    const extractFullname = (label = "") => {
        if (!label) return "";
        let name = label.split("-")[0].split("(")[0].trim();
        return name.replace(/\s+$/, "");
    };

    const sendChat = () => {
        if (!chatInput.trim()) return;
        const payload = {
            work_id: workId,
            target_id: targetId,
            message_content: chatInput,
            user_id: user.data.id,
            type: 'chat',
        };
        Axios.post(URL_LIST_ALL + 'works_order_messages', payload, user.config)
            .then(res => { if (res.data.status === "success") setChatInput(""); })
            .catch(err => console.error(err));
    };

    return (
        <div className="w-100 h-100 form-group message-group d-flex flex-column">
            <div className="w-100 position-relative border rounded d-flex flex-column flex-grow-1">
                <div className="w-100 ms-header p-2 border-bottom bg-white">
                    <h5 className="w-100 text-center mb-0" style={{ fontSize: '13px', fontWeight: 'bold' }}>Hoạt động</h5>
                </div>

                {/* Nội dung tin nhắn */}
                <div className="list-message flex-grow-1 overflow-auto">
                    {messages.length === 0 && !loading && (
                        <div className="text-center text-muted mt-5 small">Chưa có hoạt động nào.</div>
                    )}
                    {messages.map((ms) => (
                        <div className="w-100 message-item border-bottom py-2" key={ms.id}>
                            <strong className="text-primary">{ms.fullname} ({ms.email}): </strong>
                            <span className="w-100 d-inline-block" style={{ whiteSpace: "pre-line" }}>{linkify(ms.message_content)}</span><br />
                            <small className="text-muted">
                                <span className="far fa-clock mr-1"></span>
                                <Moment format="HH:mm DD/MM/YYYY">{new Date(ms.datecreate * 1000)}</Moment>
                            </small>
                        </div>
                    ))}
                    <div ref={chatEndRef} />
                </div>

                {/* Gợi ý Tag tên (Hiển thị phía trên ô nhập liệu) */}
                {showSuggest && (
                    <div className="position-absolute bg-white border rounded shadow-lg w-100" 
                         style={{ bottom: '45px', zIndex: 100, maxHeight: '150px', overflowY: 'auto' }}>
                        {usersSuggest.map((u, i) => (
                            <div key={i} className="p-2 border-bottom item-suggest" 
                                 style={{ cursor: 'pointer' }}
                                 onClick={() => handleSelectUser(u)}>
                                <strong>{extractFullname(u.fullname)}</strong> <small className="text-muted">({u.email})</small>
                            </div>
                        ))}
                    </div>
                )}

                {/* Ô nhập liệu */}
                <div className="message-action border-top bg-light">
                    <div className="input-group">
                        <input
                            ref={inputRef}
                            type="text"
                            className="form-control input-comment-ttr"
                            placeholder="Nhập nội dung hoặc gõ @ để nhắc tên..."
                            value={chatInput}
                            onChange={(e) => onComment(e.target.value)}
                            onKeyPress={(e) => e.key === 'Enter' && sendChat()}
                        />
                        <div className="input-group-append">
                             <button type="button" className="btn btn-sm btn-succss" onClick={sendChat} disabled={!chatInput.trim()}>
                                <img src={iconsend} alt="send" />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}